import axios from '@/plugins/axios'

export default {
  async SUBSCRIPTION ({ commit, state }, payload) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.post('subscription', payload, options)
      .then((response) => {
        commit('loadingFail')
        return response
      }).catch((error) => {
        commit('loadingFail')
        return error
      })
  },
  async SETUP_INTENT ({ commit, state }) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.post('subscription/setup-intent', {}, options).then((response) => {
      commit('loadingFail')
      return response
    })
  },
  async PAYMENT_METHOD ({ commit, state }, payload) {
    const options = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return axios.post('subscription/payment-methods', payload, options).then((response) => {
      commit('loadingFail')
      return response
    })
  },
  async MY_SUBSCRIPTION_HISTORY ({ commit, state }, payload) {
    const data = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return new Promise((resolve, reject) => {
      axios.get('profile/subscription', data)
        .then((response) => {
          commit('loadingFail')
          resolve(response.data)
        })
        .catch((error) => {
          commit('loadingFail')
          reject(error)
        })
    })
  },
  async SUBSCRIPTION_PLANS ({ commit, state }, payload) {
    const data = {
      headers: {
        Authorization: 'Bearer ' + state.access_token
      }
    }
    commit('loading')
    return new Promise((resolve, reject) => {
      axios.get('subscription/plans', data)
        .then((response) => {
          commit('loadingFail')
          resolve(response.data)
        })
        .catch((error) => {
          commit('loadingFail')
          reject(error)
        })
    })
  },
  async CEP_CONSULT ({ commit }, payload) {
    commit('loading')
    return new Promise((resolve, reject) => {
      axios.get('pay/cep/' + payload)
        .then((response) => {
          commit('loadingFail')
          resolve(response.data)
        })
        .catch((error) => {
          commit('loadingFail')
          reject(error)
        })
    })
  }

}
